import React from 'react';
import { IntlKeys } from '../../constants/IntlKeys';
import { FormattedMessage } from 'react-intl';
import { Popup } from './Popup';

export const ErrorCatchFallback = () => (
  <Popup titleKey={IntlKeys.ERROR_STEP_TITLE}>
    <FormattedMessage id={IntlKeys.ERROR_STEP_MESSAGE} />
  </Popup>
);
